/**
 *
 * SalaryForm
 *
 */

import React from "react";
import PropTypes from "prop-types";
import { readRemoteFile } from "react-papaparse";

import {
  deepClone,
  constantData,
  setConstantData,
  setResultsData,
  getSelectOptions,
  sortWithLookupArray,
} from "helpers";

import DataCSV from "data/data.csv";
import {
  salaryRanges,
  formIntro,
  positionsLookupArray,
  experienceLookupArray,
} from "data/data";
import Select from "components/Select";
import Button from "components/Button";
import Radio from "components/Radio";
import Label from "components/Label";
import Toggle from "components/Toggle";

import SalaryFormWrapper from "./styles/SalaryFormWrapper";
import SalaryHeader from "./styles/SalaryHeader";
import SalaryInfo from "./styles/SalaryInfo";
import SalaryRequiredText from "./styles/SalaryRequiredText";
import SalaryHorizontalWrapper from "./styles/SalaryHorizontalWrapper";
import RequiredFields from "./styles/RequiredFields";

class SalaryForm2 extends React.PureComponent {
  constructor() {
    super();

    this.selectCountry = this.selectCountry.bind(this);
    this.selectCity = this.selectCity.bind(this);
    this.selectState = this.selectState.bind(this);
    this.selectEducation = this.selectEducation.bind(this);
    this.selectExperience = this.selectExperience.bind(this);
    this.selectGender = this.selectGender.bind(this);
    this.selectSalary = this.selectSalary.bind(this);
    this.selectIndustry = this.selectIndustry.bind(this);
    this.selectPosition = this.selectPosition.bind(this);
    this.handleClick = this.handleClick.bind(this);
    this.handleRadio = this.handleRadio.bind(this);
    this.handleAdvanced = this.handleAdvanced.bind(this);
    this.showRadio = this.showRadio.bind(this);

    this.state = {
      formData: {
        region: "",
        country: "",
        city: "",
        state: "",
        education: "",
        industry: "",
        position: "",
        experience: "",
        gender: "",
        salary: "",
        userResponseIndex: "",
      },
      filtersArray: [],
      countryResponses: [],
      selectedCountryIndexes: [],
      selectedStateIndexes: [],
      countryFormAlert: false,
      showAdvanced: false,
    };
  }

  componentDidMount() {
    readRemoteFile(DataCSV, {
      complete: (results) => {
        setConstantData(results.data, this.props.columnHeaders);
        this.setState({
          countryResponses:
            results.data[0] && constantData.responses
              ? getSelectOptions("countryResponses")
              : [],
          cityResponses:
            results.data[0] && constantData.responses
              ? getSelectOptions("cityResponses")
              : [],
          educationResponses:
            results.data[0] && constantData.responses
              ? getSelectOptions("educationResponses")
              : [],
          stateResponses:
            results.data[0] && constantData.responses
              ? getSelectOptions("stateResponses")
              : [],
          experienceResponses:
            results.data[0] && constantData.responses
              ? getSelectOptions("experienceResponses")
              : [],
          genderResponses:
            results.data[0] && constantData.responses
              ? getSelectOptions("genderResponses")
              : [],
          industryResponses:
            results.data[0] && constantData.responses
              ? getSelectOptions("industryResponses")
              : [],
          positionResponses:
            results.data[0] && constantData.responses
              ? getSelectOptions("positionResponses")
              : [],
        });
      },
    });
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.filtersArray !== this.props.filtersArray) {
      this.setState(
        {
          filtersArray: this.props.filtersArray,
        },
        () => {
          setResultsData({
            props: this.props,
            filtersArray: this.state.filtersArray,
            formData: this.state.formData,
          });
          this.props.displayResults();
        }
      );
    }

    if (prevState.formData.country !== this.state.formData.country) {
      let newFormdata = deepClone(this.state.formData);
      newFormdata.state = "";
      newFormdata.city = "";
      this.setState(
        {
          formData: newFormdata,
        },
        () => {
          setResultsData({
            props: this.props,
            filtersArray: this.state.filtersArray,
            formData: this.state.formData,
          });
        }
      );
    }

    if (prevState.formData.state !== this.state.formData.state) {
      let newFormdata = deepClone(this.state.formData);
      newFormdata.city = "";
      this.setState(
        {
          formData: newFormdata,
        },
        () => {
          setResultsData({
            props: this.props,
            filtersArray: this.state.filtersArray,
            formData: this.state.formData,
          });
        }
      );
    }

    if (
      prevState.selectedCountryIndexes.length !==
        this.state.selectedCountryIndexes.length ||
      prevState.selectedStateIndexes.length !==
        this.state.selectedStateIndexes.length
    ) {
      this.setState({
        cityResponses: constantData.responses
          ? getSelectOptions("cityResponses", [
              this.state.selectedCountryIndexes,
              this.state.selectedStateIndexes,
            ])
          : [],
      });
    }
  }

  selectCountry(val) {
    this.setState(() => {
      const newFormData = deepClone(this.state.formData);
      newFormData.country = val;

      let countryIndexes = [];
      constantData.responses.countryResponses.forEach((response, index) => {
        if (response === val) {
          countryIndexes.push(index);
        }
      });
      this.props.updateFormData(newFormData);
      return {
        formData: newFormData,
        selectedCountryIndexes: countryIndexes,
        selectedStateIndexes: [],
        filtersArray: ['country']
      };
    });
    this.setState({
      countryFormAlert: false,
    });

    
  }

  selectState(val) {
    this.setState(() => {
      const newFormData = deepClone(this.state.formData);
      newFormData.state = val;

      let stateIndexes = [];
      constantData.responses.stateResponses.forEach((response, index) => {
        if (response === val) {
          stateIndexes.push(index);
        }
      });

      return {
        formData: newFormData,
        selectedStateIndexes: stateIndexes,
      };
    });
  }

  selectCity(val) {
    this.setState(() => {
      const newFormData = deepClone(this.state.formData);
      newFormData.city = val;
      return { formData: newFormData };
    });
  }

  selectEducation(val) {
    this.setState(() => {
      const newFormData = deepClone(this.state.formData);
      newFormData.education = val;
      return { formData: newFormData };
    });
  }

  selectExperience(val) {
    this.setState(() => {
      const newFormData = deepClone(this.state.formData);
      newFormData.experience = val;
      return { formData: newFormData };
    });
  }

  selectGender(val) {
    this.setState(() => {
      const newFormData = deepClone(this.state.formData);
      newFormData.gender = val;
      return { formData: newFormData };
    });
  }

  selectSalary(val) {
    this.setState(() => {
      const newFormData = deepClone(this.state.formData);
      newFormData.salary = val;
      newFormData.userResponseIndex = salaryRanges.indexOf(val);
      return { formData: newFormData };
    });
  }

  selectIndustry(val) {
    this.setState(() => {
      const newFormData = deepClone(this.state.formData);
      newFormData.industry = val;
      return { formData: newFormData };
    });
  }

  selectPosition(val) {
    this.setState(() => {
      const newFormData = deepClone(this.state.formData);
      newFormData.position = val;
      return { formData: newFormData };
    });
  }

  handleRadio(event) {
    const type = event.target.name;
    const value = event.target.value;
    const newFormData = deepClone(this.state.formData);
    if (this.state.formData[type] === value) {
      newFormData[type] = "";
      this.setState({
        formData: newFormData,
      });
    } else {
      newFormData[type] = value;
      this.setState({
        formData: newFormData,
      });
    }
  }

  handleClick() {
    const { formData } = this.state;
    const { country } = formData;

    if (country) {
      this.props.displayResults();
      this.setState({
        countryFormAlert: false,
      });
    } else {
      this.setState({
        countryFormAlert: true,
      });
    }

    window.scroll({
      top: 0,
      left: 0,
      behavior: "smooth",
    });

    // Use the passed method to update the App's state
    // this.state.updateBarChartData({
    //   // get from state
    //   chartData: this.state.chartData,
    //   labels: this.state.labels,
    //   userResponseIndex: this.state.userResponseIndex,
    // });

    this.props.updateBarChartData(this.state, this.props);
    // this.props.updateBarChartData();
    // this.props.displayResults();
    // this.props.updateResultsData("test");

    // this.setState({
    //   resultsData: {
    //     ...this.state.resultsData,
    //   },
    // });
  }

  handleAdvanced() {
    this.setState((prevProps) => {
      return {
        showAdvanced: !prevProps.showAdvanced,
      };
    });
  }

  showRadio(name, responses, label) {
    const radioArray = responses
      ? responses.map((response) => {
          return (
            <Radio
              label={response.charAt(0).toUpperCase() + response.slice(1)}
              value={response}
              sendDataCallback={this.handleRadio}
              name={name}
              checked={this.state.formData[name]}
            />
          );
        })
      : "";
    const result = (
      <>
        <Label title={label} />
        <div style={{ display: "flex", flexWrap: "wrap", width: "100%" }}>
          {radioArray}
        </div>
      </>
    );
    return result;
  }

  render() {
    const {
      formData,
      countryResponses,
      stateResponses,
      educationResponses,
      experienceResponses,
      genderResponses,
      industryResponses,
      positionResponses,
      cityResponses,
      showAdvanced,
    } = this.state;

    const { country } = formData;
    const { isResultsDisplayed } = this.props;
    const { countryFormAlert } = this.state;

    return (
      <SalaryFormWrapper
        isResultsDisplayed={isResultsDisplayed}
        style={{
          padding: "0",
        }}
      >
        <div>
          {/* <SalaryHeader>Salary calculator</SalaryHeader> */}
          {/* <SalaryInfo>{formIntro}</SalaryInfo> */}
          <Select
            options={countryResponses && countryResponses.sort()}
            sendDataCallback={this.selectCountry}
            label={"Select your country"}
            isRequired={true}
            showError={countryFormAlert}
          />
          {country === "United States" ? (
            <Select
              options={stateResponses && stateResponses.sort()}
              sendDataCallback={this.selectState}
              label={"Select your state"}
            />
          ) : (
            ""
          )}
          <Select
            options={positionResponses && positionsLookupArray}
            sendDataCallback={this.selectPosition}
            label={"Select your position"}
          />
          <Select
            options={industryResponses && industryResponses.sort()}
            sendDataCallback={this.selectIndustry}
            label={"Select industry"}
          />
          <Select
            options={salaryRanges}
            sendDataCallback={this.selectSalary}
            isSalaryRange={true}
            label={"Select your current annual salary range (USD)"}
          />
          <RequiredFields>
            <Toggle
              label={"Show advanced options"}
              handleToggle={this.handleAdvanced}
            />
            <SalaryRequiredText />
          </RequiredFields>
          {showAdvanced ? (
            <>
              <Select
                options={cityResponses && cityResponses.sort()}
                sendDataCallback={this.selectCity}
                label={"Select your city"}
              />
              {this.showRadio(
                "education",
                educationResponses,
                "Select your education level"
              )}
              {this.showRadio(
                "experience",
                experienceLookupArray,
                "Select your experience"
              )}
              {this.showRadio("gender", genderResponses, "Select your gender")}
            </>
          ) : (
            ""
          )}
          <SalaryHorizontalWrapper>
            <Button
              title={"Calculate Salary"}
              handleClick={this.handleClick}
              disabled={!formData.country}
            />
          </SalaryHorizontalWrapper>
          {/* <SalaryHorizontalWrapper>
            <Button
              title={"Calculate Salary"}
              handleClick={this.handleClick}
              disabled={
                !formData.country ||
                !formData.position ||
                !formData.industry ||
                !formData.salary
              }
            />
          </SalaryHorizontalWrapper> */}
        </div>
      </SalaryFormWrapper>
    );
  }
}

SalaryForm2.propTypes = {
  columnHeaders: PropTypes.object,
  salaryRanges: PropTypes.array,
};

export default SalaryForm2;
